<template>
  <div>
    注册
  </div>

</template>

<script>
    export default {
        name: "Login"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue